import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig, UrlModule } from '@spartacus/core';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';
import { KnBrAddToCartModule } from '../../base/components/kn-br-add-to-cart/kn-br-add-to-cart.module';
import { KnBrAddToQuoteModule } from '../../base/components/kn-br-add-to-quote/kn-br-add-to-quote.module';
import { KnBrQuickEntryComponent } from './kn-br-quick-entry.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    UrlModule,
    KnBrAddToCartModule,
    KnBrAddToQuoteModule,
    KnBrDirectiveModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrQuickEntryComponent: {
          component: () => import('./kn-br-quick-entry.component').then((c) => c.KnBrQuickEntryComponent),
        },
      },
    } as CmsConfig),
    RouterModule.forChild([
      {
        data: { pageLabel: '/quick-entry', cxRoute: 'quickEntry' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          quickEntry: {
            paths: ['quick-entry'],
          },
        },
      },
    } as RoutingConfig),
  ],
  declarations: [KnBrQuickEntryComponent],
})
export class KnBrQuickEntryModule { }
